var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHamburgerClose = function SvgHamburgerClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 89 89",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.303 45.45 75.222 18.48a2.691 2.691 0 0 0-1.927-4.48 2.683 2.683 0 0 0-1.865.683L44.5 41.642 17.57 14.684a2.683 2.683 0 0 0-3.688.104 2.69 2.69 0 0 0-.104 3.694l26.92 26.968-26.92 26.967A2.69 2.69 0 0 0 15.68 77a2.63 2.63 0 0 0 1.89-.785L44.5 49.257l26.93 26.958a2.632 2.632 0 0 0 1.89.785 2.683 2.683 0 0 0 2.475-1.657 2.693 2.693 0 0 0-.573-2.926L48.302 45.45Z",
    fill: "currentColor"
  })));
};
export { SvgHamburgerClose as ReactComponent };
export default __webpack_public_path__ + "45df0c17487c40a96033ec4863b5f8de.svg";